import { atom } from "@reatom/framework";
import { getMeRequest } from "src/store/fetchers/getMeRequest";

export const openConsentModalAtom = atom((ctx) => {
  const user = ctx.spy(getMeRequest.dataAtom);

  if (!user) return false;

  return user.consentToCommunications === null;
}, "openConsentModalAtom");
